/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:25:51
 * @FilePath: \mrc-ess-fronted\src\router\index.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-22 14:52:48
 */
import Vue from "vue";
import Router from "vue-router";
import routers from "@/router/routers";
import router_addmin from "@/router/router_admin";

Vue.use(Router);
// Layout
import Home from "@/Layout/Home";
// Login
import forgetPassword from "@/Page/Ess/ForgetPassword/index.vue";
import Login from "@/Page/Ess/Login/Login";
import Roster from "@/Page/Other/Roster/Roster.vue";
import Page404 from "@/Layout/404Page";

// 解决重复重定向报错start
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

// 解决重复重定向报错end
let root_Routers = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/forget_password/:login_url",
    name: "ForgetPassword",
    component: forgetPassword,
  },
  {
    path: "/system/404",
    name: "system_404Page",
    component: Page404,
  },
  {
    path: "/",
    name: "Home",
    redirect: "/dashboard",
    component: Home,
    children: routers,
  },
  {
    path: "/admin",
    name: "HomeAdmin",
    redirect: "/admin/dashboard",
    component: Home,
    children: router_addmin,
  },
  {
    path: "/roster-print/:args",
    name: "roster-print",
    component: Roster,
  },
  {
    path: "/app/custom-form/:args",
    name: "custom-form",
    component: () => import("@/Page/Other/CustomForm/index"),
  },
];

export default new Router({
  mode: "history", //2020-10-14，Brain
  routes: root_Routers,
});
